










import Glide from '@glidejs/glide';

import {
  Component,
  Vue,
} from 'vue-property-decorator';

@Component
export default class CarouselSlide extends Vue {
  get index() {
    return this.$parent.$children.findIndex((slide) => (slide === this));
  }
}

